import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { PROPPLAN_INIT_LOADING, PROPPLAN_INIT_SUCCESS, PROPPLAN_INIT_FAIL } from '@/store/types'

export const state = {
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {

}

const mutations = {
  [PROPPLAN_INIT_LOADING](state, err) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [PROPPLAN_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [PROPPLAN_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async propPlanManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.propPlanManagement
    commit(PROPPLAN_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(PROPPLAN_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(PROPPLAN_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
